
import React, {Component} from "react";
import PageTitle from "../Components/Theme/PageTitle";
import DashboardLayout from "../Components/Theme/DashboardLayout";


export default class AdjustWorkTimes extends Component {

    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'Adjust Work Times'}
                           subTitle={''}/>

            </DashboardLayout>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AdjustWorkTimesPage.js